import { Box } from '@bechtel/gds';
import { InventoryStatus } from '@bechtel/ht-types';
import styled, { css } from 'styled-components';
import { EditToolStatusStyledProps } from './type';

const getToolStyled = (props: EditToolStatusStyledProps) => {
  const { status } = props;
  switch (status) {
    case InventoryStatus.GOOD:
      return css`
        border: 1px solid ${({ theme }) => theme.colors.green[300]};
        background-color: ${({ theme }) => theme.colors.green[100]};
        Button,
        :focus {
          color: ${({ theme }) => theme.colors.green[400]};
          background-color: ${({ theme }) => theme.colors.green[100]};
        }
      `;
    case InventoryStatus.WRITEOFF:
      return css`
        border: 1px solid ${({ theme }) => theme.colors.red[300]};
        background-color: ${({ theme }) => theme.colors.red[100]};

        Button,
        :focus {
          color: ${({ theme }) => theme.colors.red[400]};
          background-color: ${({ theme }) => theme.colors.red[100]};
        }
      `;
    case InventoryStatus.REPAIR:
      return css`
        border: 1px solid ${({ theme }) => theme.colors.orange[300]};
        background-color: ${({ theme }) => theme.colors.orange[100]};
        Button,
        :focus {
          color: ${({ theme }) => theme.colors.orange[400]};
          background-color: ${({ theme }) => theme.colors.orange[100]};
        }
      `;
  }
};
const getToolStatusIconStyled = (props: EditToolStatusStyledProps) => {
  const { status, disabled } = props;
  if (disabled) {
    return css`
      background-color: ${({ theme }) => theme.colors.grey[500]};
    `;
  }
  switch (status) {
    case InventoryStatus.GOOD:
      return css`
        background-color: ${({ theme }) => theme.colors.green[500]};
      `;
    case InventoryStatus.WRITEOFF:
      return css`
        background-color: ${({ theme }) => theme.colors.red[500]};
      `;
    case InventoryStatus.REPAIR:
      return css`
        background-color: ${({ theme }) => theme.colors.orange[500]};
      `;
  }
};
const getToolStatusTextStyled = (props: { status: InventoryStatus }) => {
  const { status } = props;

  switch (status) {
    case InventoryStatus.GOOD:
      return css`
        padding-left: ${({ theme }) => theme.spacings[550]};
      `;

    case InventoryStatus.REPAIR:
      return css`
        padding-left: ${({ theme }) => theme.spacings[500]};
      `;
  }
};

export const ToolStatusIconStyled = styled(Box)<EditToolStatusStyledProps>`
  ${({ theme }) => css`
    border-radius: ${theme.spacings[450]};
    width: ${theme.spacings[600]};
    height: ${theme.spacings[600]};
    padding: ${theme.spacings[300]};
  `}
  ${getToolStatusIconStyled};
`;

export const ToolStatusTextStyled = styled(Box)<{ status: InventoryStatus }>`
  ${getToolStatusTextStyled};
`;

export const OptionStyled = styled(Box)`
  justify-content: left;
  align-items: center;
`;

export const ToolStatusStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  py: { sm: '100' },
})<EditToolStatusStyledProps>`
  border-radius: ${({ theme }) => theme.radii[800]};
  height: 36px;
  width: 134px;
  padding-left: ${({ theme }) => theme.spacings[100]};
  Button,
  :focus {
    border: none !important;
    box-shadow: none !important;
  }
  ${getToolStyled};
`;
